import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "../../../../environments/environment";
import { map, of } from "rxjs";
import {AddIngredeintItemModel } from "../../models/menu-items/add-ingredient-item.model";
import { SearchByVenueHelperModel } from "../../models/inventory/search-by-venue-helper-model";
import { AddOrEditInventoryItemModel} from "../../models/inventory/add-or-edit-inventory-item.model";

const SUPPLIES_API = environment.apiURL + '/api/gmn/Supply/';
const MNG_SUPPLIES_API = environment.apiURL + '/api/mng/Supply/';
const UnitsOfMeasurment = environment.apiURL + "/api/gmn/UnitOfMeasurement/";

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {}
  //#endregion

  //#region Public Methods
  listSuppliesForCompany(CompanyId: string,filter: string){
    let url = SUPPLIES_API + "listsuppliessimple?CompanyId=" + CompanyId +"&filter="+filter;
    return this._httpService.httpGet(url)
        .pipe(map(response => {
            return response;
        }))
  }

  listUnitOfMeasurements() {
    let url = UnitsOfMeasurment + "listUnitOfMeasurements";
    return this._httpService.httpGet(url)
        .pipe(map(response => {
            return response;
        }))
  }

  listUnitOfMeasurementsForManager() {
    let url = MNG_SUPPLIES_API + "listUnitOfMeasurements";
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }))
  }

  addSupply(model: AddIngredeintItemModel){
    let url = SUPPLIES_API + "addsupply";
    return this._httpClient
      .post<any>(url, model, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }))
  }

  addInventoryItem(model: AddOrEditInventoryItemModel){
    let url = MNG_SUPPLIES_API + 'addsupply';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  editInventoryItem(model: AddOrEditInventoryItemModel){
    let url = MNG_SUPPLIES_API + 'updatesupply';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }
  reorderInventoryItem(model: AddOrEditInventoryItemModel){
    let url = MNG_SUPPLIES_API + 'orderandreordersupply';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteInventoryItem(id: string){
    let url = '';
    return this._httpService.httpPost(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listSuppliersForCompany(companyId: string) {
    let url = MNG_SUPPLIES_API + "listallsuppliersforcombo?CompanyId=" + companyId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  loadInventoryForVenue(model: SearchByVenueHelperModel){
    let url = MNG_SUPPLIES_API + "listsupplies?VenueId=" + model.venueId + "&PageNumber=" + model.pageNumber + "&PageSize=" + model.pageSize + "&filter="+model.filter;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }))
  }

  loadSuppliersForVenue(venueId: string, startDate: string, endDate: string){
    let url = MNG_SUPPLIES_API + "listsuppliers" + "?VenueId=" + venueId + "&StartDate=" + startDate + "&EndDate=" + endDate;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }))
  }

  loadSupplierOrdersDetails(supplierName: string,venueId: string){
    let url = MNG_SUPPLIES_API + "listsupplierorders" + "?SupplierName=" + supplierName + "&VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }))
  }
  //#endregion
}
